import { debounceTime } from "rxjs";
import { Utils } from "../../02_utils/utils";


export class ToTop {
  private toTopButtons: NodeListOf<HTMLElement>;

  constructor(private $utils: Utils) {
    this.toTopButtons = document.querySelectorAll('.js-to-top');

    this.$utils.scrollListener.pipe(
      debounceTime(100)
    ).subscribe(() => {
      this.toggleButtonVisibility();
    });

    this.toTopButtons?.forEach(button => {
      button.addEventListener('click', () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }, {passive: true});
    });
  }

  private toggleButtonVisibility() {
    const body = document.body,
        html = document.documentElement;

    const height = Math.max( body.scrollHeight, body.offsetHeight,
                          html.clientHeight, html.scrollHeight, html.offsetHeight );

    if (height < 4000) {
      this.$utils.addOrRemoveClases('remove', 'visible', this.toTopButtons);
      return;
    }

    if (window.scrollY > 300) {
      this.$utils.addOrRemoveClases('add', 'visible', this.toTopButtons);
    } else {
      this.$utils.addOrRemoveClases('remove', 'visible', this.toTopButtons);
    }
  }
}
